import styled from '@emotion/styled';

// eslint-disable-next-line import/prefer-default-export
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
`;

export const MobileWrapper = styled.div`
  display: none;

  ${({ theme }) => theme.media.mobile} {
    display: block;
  }
`;

export const List = styled.ul`
  list-style: none;
  li {
    margin-top: 1rem;
  }
`;
